/**
 * Preferências do login guardadas NESTE aparelho/navegador (só conveniência; nada secreto): a
 * forma de entrar (usuário ou e-mail) e o código da empresa. Usado pelo ERP Web e pelo
 * CaféGestor Vendedor. Sem armazenamento disponível, valem os padrões.
 */
export type LoginMode = "usuario" | "email";
export type LoginPrefs = { mode: LoginMode; loginCode: string };

const KEY = "cafegestor.login";

export function readLoginPrefs(): LoginPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { mode: "usuario", loginCode: "" };
    const v = JSON.parse(raw) as Partial<LoginPrefs>;
    return {
      mode: v.mode === "email" ? "email" : "usuario",
      loginCode: typeof v.loginCode === "string" ? v.loginCode : "",
    };
  } catch {
    return { mode: "usuario", loginCode: "" };
  }
}

export function writeLoginPrefs(prefs: LoginPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(prefs));
  } catch {
    // navegador sem armazenamento: vale só nesta visita
  }
}
